import { Suspense, useEffect } from "react";
import { BrowserRouter, useRoutes } from "react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { queryClient } from "@/lib/queryClient";
import { PwaProvider } from "@/lib/pwa-context";
import { useAuthStore } from "@/features/auth/authStore";
import { ApiStatusBanner } from "@/components/ApiStatusBanner";
import { routes } from "@/routes";
function RoutedApp() {
const element = useRoutes(routes);
return (
<Suspense
fallback={
<div className="flex h-dvh items-center justify-center">
<div className="h-8 w-8 animate-spin rounded-full border-2 border-border border-t-gray-900" />
</div>
}
>
{element}
</Suspense>
);
}
export default function App() {
const init = useAuthStore((s) => s.init);
useEffect(() => {
const unsubscribe = init();
return unsubscribe;
}, [init]);
return (
<QueryClientProvider client={queryClient}>
<PwaProvider>
<BrowserRouter>
<div className="sticky top-0 z-50">
<ApiStatusBanner />
</div>
<RoutedApp />
</BrowserRouter>
</PwaProvider>
<Toaster
position="top-right"
toastOptions={{ style: { fontSize: "14px" } }}
/>
</QueryClientProvider>
);
}
